import { render } from "./VMarkdownContent.vue?vue&type=template&id=7a0e5750"
import script from "./VMarkdownContent.vue?vue&type=script&lang=ts"
export * from "./VMarkdownContent.vue?vue&type=script&lang=ts"

const cssModules = script.__cssModules = {}
import style0 from "./VMarkdownContent.vue?vue&type=style&index=0&id=7a0e5750&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script